import { gql } from '@urql/core'
export const REPORT_MUTATION = gql`
  mutation CreateReport($input: CreateReportInput!) {
    createReport(input: $input)
  }
`
